Auth = require 'db/auth'
AddTagView = require 'views/organization/add-tag-view'
EditTagView = require 'views/organization/edit-tag-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
Controller = require 'controller'
track = require 'debug/track'
_ = require 'underscore'
$ = require 'jquery'
getExperiment = require 'lib/experiments/simple-test'

t = require('views/internal/teacup-with-helpers')('board_collections')

collectionsListHelper = t.renderable (tags, showCheck) ->
  if tags
    t.ul '.select-tags-list', ->
      for tag in tags
        t.li '.select-tags-list-item.js-tag-item',
          'data-id-tag': tag.id
        , ->
          t.a '.select-tags-list-item-name-link.js-toggle-tag', ->
            if showCheck
              t.icon 'check', class: 'select-tags-list-item-name-link-check-icon'
            t.text tag.get('name')

collectionsList = t.renderable (filteredTags) ->
  collectionsListHelper(filteredTags.associated, true)
  collectionsListHelper(filteredTags.notAssociated, false)

template = t.renderable ({ board, collectionsEnabled, billingUrl, orgUrl, hasTags, onOldBC, hideExplainer }) ->
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  if !collectionsEnabled
    if adsLayoutExperimentEnabled
      t.div '.collections-upsell.ads-layouts-experiment', ->
        t.div '.collections-upsell-body', ->
          t.h4 '.collections-upsell-header', ->
            t.format 'ads-title'
          t.p ->
            t.format 'collections-let-you-group-and-filter'
          t.a '.js-learn-more', { href: '/business-class', target: '_blank' }, ->
            t.format 'ads-learn-more'
          t.div '.collections-upgrade-action', ->
            if billingUrl
              t.a '.button.primary.js-upgrade', { href: billingUrl }, ->
                t.format 'ads-upgrade'
            else
              t.a '.button.primary.js-add-team', href: '#' , ->
                t.format 'ads-upgrade'
    else
      t.div '.collections-upsell', ->
        t.h4 '.collections-upsell-header', ->
          t.format 'a-focused-perspective'
        t.img '.collections-image', { src: require('images/collections/business-class-feature-roadmap.png') }
        t.p ->
          t.format 'collections-let-you-group-and-filter'
        t.p ->
          if onOldBC
            t.format 'to-unlock-collections-upgrade-old-bc'
          else
            t.format 'to-unlock-collections-upgrade'
        t.div '.collections-upgrade-action', ->
          if billingUrl
            t.a '.button.primary.js-lets-do-this', { href: billingUrl }, ->
              t.format 'lets-do-this'
          else
            t.a '.button.primary.js-add-team', href: '#' , ->
              t.format 'lets-do-this'
        t.div '.collections-upgrade-action', ->
          t.a '.collections-upgrade-cancel.js-go-back', href: '#', ->
            t.format 'no-thanks'
    return
  else
    if !hideExplainer
      t.div '.collections-info', ->
        t.span '.collections-explainer-close.js-close-explainer', ->
          t.icon 'close'
        t.img '.collections-image', { src: require('images/collections/business-class-feature-roadmap.png') }
        t.p ->
          t.format 'collections-let-you-group-and-filter'
        t.p '.js-learn-more', ->
          t.format 'learn-more-about-collections'
    t.div '.collections-select-lists', ->
      if hasTags
        t.div '.has-collections', ->
          t.p '.js-team-page', ->
            t.format 'visit-team-page-create-some',
              orgUrl: orgUrl
          t.a '.quiet-button.full.create-collection-btn.js-add-tag', { href: '#' }, ->
            t.format "create-collection"
        t.input '.js-collections-search', { type: 'text', placeholder: t.l("search-collections"), autocomplete: 'off' }
        t.div '.js-filtered-collections'
      else
        t.div '.no-collections', ->
          t.p ->
            t.format 'no-collections'
          t.p '.js-team-page', ->
            t.format 'visit-team-page-create-some',
              orgUrl: orgUrl
          t.a '.quiet-button.full.create-collection-btn.js-add-tag', { href: '#' }, ->
            t.format "create-collection"

getIdTag = (e) ->
  $(e.target).closest('.js-tag-item')[0].getAttribute('data-id-tag')

module.exports = class BoardCollectionsView extends View
  className: 'board-menu-collections-select'

  noPadding: true

  initialize: ->
    @sidebarView = @options.sidebarView
    @organization = @options?.org || @model.getOrganization()
    @collectionsEnabled = @organization? && @organization.isFeatureEnabled('tags')

    @listenTo @model, 'change:idOrganization', @refereshOrganization
    @listenTo @model, 'change:idTags', @render
    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @render

    if @collectionsEnabled
      @listenTo @organization.tagList, 'add remove reset change', @render

    super

  events:
    'click .js-add-tag': 'addTag'
    'keyup .js-collections-search': 'renderFilteredCollections'
    'click .js-toggle-tag': (e) ->
      track("Board Menu", "Collections Menu", "Toggle Collections")
      @toggleTag getIdTag(e)
    'click .js-go-back': (e) ->
      @sidebarView.popView()
      track("Board Menu", "Collections Menu", "No Thanks Button")
    'click .js-add-team': (e) ->
      Util.stop(e)
      @model.trigger 'add-to-team'
      track("Board Menu", "Collections Menu", "Lets Add To Team")
    'click .js-lets-do-this': (e) ->
      track("Board Menu", "Collections Menu", "Lets Do This Button")
    "click .js-close-explainer": (e) ->
      Auth.me().dismiss("CollectionsExplainer")
      track('Board Menu', 'Collections Menu', 'Dismiss Collections Explainer')
    'click .js-learn-more a': (e) ->
      track('Board Menu', 'Collections Menu', 'Clicks Learn More Link')
    'click .js-team-page a': (e) ->
      track('Board Menu', 'Collections Menu', 'Clicks Team Page Link')
    'click .js-upgrade': (e) ->
      track("Board Menu", "Collections Menu", "Upgrade Button")

  viewTitleKey: 'pick tags'

  addTag: (e) ->
    Util.stop(e)
    track('Board Menu', 'Collections Menu', 'Open Create Tag Menu')
    PopOver.toggle
      elem: e.target
      view: AddTagView
      options:
        model: @organization
        modelCache: @modelCache
        boardView: true

  toggleTag: (idTag) ->
    @model.toggleTag(idTag)

  filterTagsBySearch: (tags) ->
    searchVal = @_searchVal().toLowerCase()
    if _.isEmpty(searchVal)
      return tags

    _.filter(tags, (tag) -> tag.get('name')?.toLowerCase().indexOf(searchVal) > -1)

  filterTagsByAssociation: (tags, boardTags) ->
    _.groupBy(tags, (tag) => if tag.id in boardTags then 'associated' else 'notAssociated')

  _searchVal: ->
    @$('.js-collections-search').val()?.trim() ? ""

  renderFilteredCollections: ->
    if !@organization?.tagList.models.length
      return

    filteredTags = @filterTagsByAssociation(@filterTagsBySearch(@organization.tagList.models), @model.getIdTags())
    @$('.js-filtered-collections')
      .empty()
      .append(collectionsList(filteredTags))

  refereshOrganization: ->
    oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
    organization = @model.getOrganization()

    if oldOrganization?
      @stopListening oldOrganization.tagList

    @organization = organization
    @collectionsEnabled = @organization? && @organization.isFeatureEnabled('tags')

    if @collectionsEnabled
      @listenTo @organization.tagList, 'add remove reset change', @render

    @render()

  render: ->
    me = Auth.me()
    hideExplainer = me.isDismissed("CollectionsExplainer")

    onOldBC = @organization?.isPremium() && !@collectionsEnabled
    hasTags = @organization?.tagList.models.length

    if @organization
      orgUrl = Controller.getOrganizationUrl(@organization)
      billingUrl = Controller.getOrganizationBillingUrl(@organization)

    @$el.html template({
      board: @model
      collectionsEnabled: @collectionsEnabled
      billingUrl: billingUrl
      orgUrl: orgUrl
      hasTags: hasTags
      onOldBC: onOldBC
      hideExplainer: hideExplainer
    })

    @renderFilteredCollections()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-collections-select-view.coffee